import { useMemo } from 'react';
import createLinkPlugin from '@draft-js-plugins/anchor';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import createToolbarPlugin from '@draft-js-plugins/static-toolbar';
import i18n from 'i18next';

import LinkButtonBase from './LinkButton';

const { t } = i18n;

const toolbarConfig = {
  theme: {
    buttonStyles: {
      button: 'rich-editor__toolbar-button',
      active: 'rich-editor__toolbar-button_active',
    },
    toolbarStyles: {
      toolbar: 'rich-editor__toolbar',
    },
  },
};

const linkToolConfig = {
  LinkButton: LinkButtonBase,
  theme: {
    link: 'rich-editor__link',
    input: 'rich-editor__link-input',
    inputInvalid: 'rich-editor__link-input_invalid',
  },
  placeholder: t('adminInquiries.enterUrl'),
};

const useEditorPlugins = () => {
  const toolbarPlugin = useMemo(() => createToolbarPlugin(toolbarConfig), []);
  const linkPlugin = useMemo(() => createLinkPlugin(linkToolConfig), []);
  const linkifyPlugin = useMemo(() => createLinkifyPlugin(), []);

  const plugins = [toolbarPlugin, linkifyPlugin, linkPlugin];
  const { Toolbar } = toolbarPlugin;
  const { LinkButton } = linkPlugin;

  return { plugins, Toolbar, LinkButton };
};

export default useEditorPlugins;
